export default __webpack_public_path__ + "assets/front/scss/affichage-table.29bb495c25c78e7cdea5941e0a55863b.css";